const actions = {
  REQUESTING: 'ContractEmailLists/REQUESTING',
  RESPONSE_ERROR: 'ContractEmailLists/RESPONSE_ERROR',

  FETCH_CONTRACTEMAILLISTS: 'ContractEmailLists/FETCH',
  LIST_CONTRACTEMAILLIST: 'ContractEmailList/LIST',

  FETCH_CONTRACTEMAILLIST: 'ContractEmailList/FETCH',
  NEW_CONTRACTEMAILLIST: 'ContractEmailList/NEW',
  EDIT_CONTRACTEMAILLIST: 'ContractEmailList/EDIT',
  RESET_CONTRACTEMAILLIST: 'ContractEmailList/RESET',

  RE_FETCH_CONTRACTEMAILLISTS: 'ContractEmailLists/REFRESH',
  SAVE_CONTRACTEMAILLIST: 'ContractEmailList/SAVE',
  SAVE_CONTRACTEMAILLIST_RECIEVED: 'ContractEmailList/SAVE_CONTRACTEMAILLIST_RECIEVED',

  DELETE_CONTRACTEMAILLIST: 'ContractEmailList/DELETE',
  DELETE_CONTRACTEMAILLIST_RECIEVED: 'ContractEmailList/DELETE_RECIEVED',
}

export default actions
